module.exports = __webpack_public_path__ + "ad12e2e1b08944521e103a8b584fadda.svg";